import { ErrorCodes, UserStatus } from "../api/types/enums";
import { BH_ROUTES, ERROR_ROUTES } from "./constants";
const isUnprotectedPath = (currentPath) => {
    return (currentPath === BH_ROUTES.FAQ ||
        currentPath === BH_ROUTES.REGISTER ||
        currentPath.includes(BH_ROUTES.ERROR_BASE) ||
        currentPath.includes(BH_ROUTES.INVITE_BASE));
};
export const getExpectedBetaPath = ({ userStatus, currentPath, hasInviteCode, platform, }) => {
    if (isUnprotectedPath(currentPath)) {
        return currentPath;
    }
    if (userStatus === UserStatus.Unverified || !userStatus) {
        if (currentPath === BH_ROUTES.REGISTER) {
            return currentPath;
        }
        else {
            return BH_ROUTES.BETA_HUB;
        }
    }
    if (userStatus === UserStatus.Unregistered) {
        return BH_ROUTES.REGISTER;
    }
    if (userStatus === UserStatus.Registered) {
        if (currentPath === BH_ROUTES.OPT_IN_SUCCESS || currentPath === BH_ROUTES.BETA_HUB_REGISTERED) {
            return currentPath;
        }
        else {
            return BH_ROUTES.BETA_HUB_REGISTERED;
        }
    }
    if ((userStatus === UserStatus.Invited || userStatus === UserStatus.Completed) &&
        currentPath === BH_ROUTES.PC_DOWNLOAD) {
        if (platform?.toLowerCase().includes("windows")) {
            return currentPath;
        }
        else {
            return ERROR_ROUTES.INVALID_PLATFORM;
        }
    }
    if (userStatus === UserStatus.Invited && !hasInviteCode) {
        if (currentPath === BH_ROUTES.INVITEE_SUCCESS ||
            currentPath === BH_ROUTES.BETA_HUB_INVITEE_ACCEPTED ||
            currentPath === BH_ROUTES.CONNECT_CONSOLE) {
            return currentPath;
        }
        else {
            return BH_ROUTES.BETA_HUB_INVITEE_ACCEPTED;
        }
    }
    if (userStatus === UserStatus.Invited && hasInviteCode) {
        if (currentPath === BH_ROUTES.BETA_HUB_ACCEPTED || currentPath === BH_ROUTES.CONNECT_CONSOLE) {
            return currentPath;
        }
        else {
            return BH_ROUTES.BETA_HUB_ACCEPTED;
        }
    }
    if (userStatus === UserStatus.Completed && !hasInviteCode) {
        return BH_ROUTES.BETA_HUB_INVITEE_COMPLETE;
    }
    if (userStatus === UserStatus.Completed && hasInviteCode) {
        return BH_ROUTES.BETA_HUB_COMPLETE;
    }
};
export const getErrorPageRoute = (errorCode) => {
    switch (errorCode) {
        case ErrorCodes.CAMPAIGN_NOT_FOUND:
            return ERROR_ROUTES.CAMPAIGN_INACTIVE;
        case ErrorCodes.CAMPAIGN_NOT_ACTIVE:
            return ERROR_ROUTES.BETA_REGISTRATION_CLOSED;
        case ErrorCodes.MAX_REDEEMED_CODE:
            return ERROR_ROUTES.MAX_REDEEMED;
        case ErrorCodes.MISSING_ENTITLEMENT:
            return ERROR_ROUTES.NOT_ENTITLED;
        case ErrorCodes.UNAUTHORIZED:
            return ERROR_ROUTES.UNAUTHORIZED;
        case ErrorCodes.INVALID_CODE:
            return ERROR_ROUTES.INVALID_LINK;
        case ErrorCodes.ALREADY_ENTITLED:
            return ERROR_ROUTES.ALREADY_REGISTERED;
        case ErrorCodes.COUNTRY_FORBIDDEN:
            return ERROR_ROUTES.UNAVAILABLE_REGION;
        case ErrorCodes.RATE_LIMIT:
            return ERROR_ROUTES.RATE_LIMIT_ERROR;
        case ErrorCodes.SUBJECT_INVALID:
        case ErrorCodes.BAD_REQUEST:
        case ErrorCodes.UNKNOWN_ERROR:
        case ErrorCodes.INTERNAL_SERVER_ERROR:
        default:
            return ERROR_ROUTES.GENERAL_ERROR;
    }
};
//# sourceMappingURL=getExpectedBetaPath.js.map